// extracted by mini-css-extract-plugin
export var downArrow = "_98-0";
export var infoTooltipIcon = "_98-3";
export var label = "_98-1";
export var optionCard = "_98-4";
export var upArrow = "_98-2";